import type {IncomePropsType} from 'types/general';

const DYNAMIC_IMPORTS = {
    mobile: () => import('mobile/modal/ModalMobile.svelte'),
    desktop: () => import('desktop/modal/ModalDesktop.svelte'),
    desktopV2: () => import('../__v2__/desktop/ModalDesktop.svelte'),
};

export const getPlatformComponent = async (props?: IncomePropsType) => {
    const isMobile = props
        ? props.extraProps?.platform === 'MOBILE'
        : /Android|iPhone/i.test(navigator.userAgent);

    const isNewVersion = props?.extraProps?.version === 'v2';
    if (isMobile) {
        return (await DYNAMIC_IMPORTS.mobile()).default;
    }

    if (isNewVersion) {
        return (await DYNAMIC_IMPORTS.desktopV2()).default;
    }

    return (await DYNAMIC_IMPORTS.desktop()).default;
};
